import { A } from '@mobily/ts-belt';
import { Box, FormHelperText, List, ListItem } from '@mui/material';
import { useTranslate } from 'react-admin';

import { FormValues } from '@sh4res/bo-common/components/B2bWithdrawalBulkCreate/steps/utils';

type Props = {
  deceasedRows: Pick<FormValues['bulk_rows'][number], 'nir' | 'ntt' | 'firstname' | 'lastname'>[];
};

export const DeceasedEmployeesSection = ({ deceasedRows }: Props) => {
  const translate = useTranslate();

  if (A.isEmpty(deceasedRows)) {
    return null;
  }

  return (
    <Box mt={1} sx={{ overflowY: 'auto', maxHeight: '150px' }}>
      <FormHelperText error sx={{ fontSize: 14 }}>
        {translate('resources.bo_common.b2b.withdrawals.bulk_create.errors.deceased_employees')}
        <List dense disablePadding>
          {deceasedRows.map((row, index) => (
            <ListItem key={index} sx={{ display: 'list-item', pl: 2 }}>
              {`${row.nir || row.ntt} - ${row.firstname} ${row.lastname}`}
            </ListItem>
          ))}
        </List>
      </FormHelperText>
    </Box>
  );
};
